import React from 'react';
import { Button } from './ui/button';
import { Play, Calendar } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxyZWNvcmRpbmclMjBzdHVkaW98ZW58MHx8fHwxNzc0MzM1MDE5fDA&ixlib=rb-4.1.0&q=85"
          alt="Recording Studio"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-orange-900/90 via-orange-800/80 to-orange-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          <div className="inline-block mb-6">
            <span className="bg-orange-500/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium border border-orange-400/30">
              Studio Professionnel Marseille
            </span>
          </div>
          
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Donnez vie à votre
            <span className="block text-orange-300">musique</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-orange-100 mb-8 leading-relaxed">
            StudioKyp - Studio d'enregistrement professionnel équipé des dernières technologies.
            De l'enregistrement au mastering, nous transformons vos idées en chefs-d'œuvre sonores.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              size="lg"
              className="bg-orange-600 hover:bg-orange-700 text-white text-lg px-8 py-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
              onClick={() => scrollToSection('contact')}
            >
              <Calendar className="w-5 h-5 mr-2" />
              Réserver une session
            </Button>
            
            <Button
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-white/30 text-lg px-8 py-6 rounded-lg transition-all duration-300"
              onClick={() => scrollToSection('portfolio')}
            >
              <Play className="w-5 h-5 mr-2" />
              Découvrir nos réalisations
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-6 mt-16 pt-16 border-t border-white/20">
            <div>
              <div className="text-4xl font-bold text-white mb-2">10+</div>
              <div className="text-orange-200 text-sm">Années d'expérience</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-white mb-2">500+</div>
              <div className="text-orange-200 text-sm">Projets réalisés</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-white mb-2">100%</div>
              <div className="text-orange-200 text-sm">Satisfaction client</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-white/70 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
